// extracted by mini-css-extract-plugin
module.exports = {"header":"Token_header__3zHnI","title":"Token_title__1Jo8E","name":"Token_name__2rlDs","description":"Token_description__3GiNN","extra":"Token_extra__Kp-ak"};